/**
 * Statisk indhold og billeder.
 *
 * BEMÆRK: Firmaoplysninger (navn, telefon, e-mail, CVR, adresse) ligger IKKE her.
 * De hentes fra Firestore-dokumentet settings/company, så der kun findes én kilde,
 * og de kan rettes af administratoren under Admin → Indstillinger.
 */
/**
 * Fast offentlig kontakt-e-mail. Kan IKKE ændres fra admin, og værdien i
 * settings/company ignoreres bevidst for det offentlige site.
 * Skrives altid med æ — aldrig punycode.
 */
export const CONTACT_EMAIL = 'kontakt@lykkeværk.dk'

export const company = {
  /** Stående logo — bruges stort på hvide flader. */
  logo: 'https://cdn.magicpatterns.com/uploads/nHxi4VXqzJoxJUMisTPGYE/image.png',
  /** Kvadratisk logomærke uden tekst — bruges som favicon og app-ikon. */
  logoMark: 'https://cdn.magicpatterns.com/uploads/hCqeATb4WBsqrVsZ6orgZg/LOGO_Uden_Skrift.png',
  /** Liggende logo med gennemsigtig baggrund — bruges i topbjælker. */
  logoWide: 'https://cdn.magicpatterns.com/uploads/eUzyTHyvYNvXG7KJGUf9oy/FIRMAgennemsigtig.png',
}

export interface Service {
  title: string
  description: string
  /** Konkrete eksempler i stedet for generelle påstande. */
  examples: string
}

export const services: Service[] = [
  {
    title: 'Multiservice',
    description:
      'Har du en mindre eller større praktisk opgave, du ikke selv har tid, værktøj eller mulighed for at få lavet? Så kan jeg muligvis hjælpe.',
    examples: 'Fx oprydning, samling af møbler, småreparationer eller en hånd med flytteopgaver.',
  },
  {
    title: 'Montage',
    description: 'Skal du have noget sat op eller monteret, så send mig en beskrivelse af opgaven.',
    examples: 'Fx hylder, tv-beslag, lamper, skabe, hegn og inventar.',
  },
  {
    title: 'Vedligeholdelse',
    description:
      'Har du noget, der trænger til reparation eller vedligeholdelse, kan vi tage en snak om, hvad der giver bedst mening.',
    examples: 'Fx udskiftning af defekte dele, efterspænding, småreparationer og løbende service.',
  },
  {
    title: 'Andet',
    description:
      'Passer din opgave ikke ind i en bestemt kategori? Send den alligevel. Så finder vi ud af, om det er noget, jeg kan hjælpe med.',
    examples: '',
  },
]

export const values = [
  {
    title: 'Direkte kontakt',
    description: 'Du taler med mig — ikke et kontor eller en kundeservice.',
  },
  {
    title: 'Klare aftaler',
    description: 'Du ved, hvad opgaven koster, og hvornår jeg kommer, inden vi går i gang.',
  },
  {
    title: 'Praktiske løsninger',
    description: 'Vi finder den løsning, der giver mest mening for dig og din opgave.',
  },
  {
    title: 'Ærlig snak',
    description: 'Kan jeg ikke hjælpe med din opgave, siger jeg det med det samme.',
  },
]

/** Personen bag LYKKEVÆRK. */
export const owner = {
  name: 'Daniel Lykke',
  role: 'Indehaver af LYKKEVÆRK',
  portrait:
    'https://cdn.magicpatterns.com/uploads/4iGPhQSRVzJvDiUaxgvYSd/ChatGPT_Image_17._sep._2026,_21.15.04.png',
  intro: [
    'Mit navn er Daniel Lykke, og jeg står bag LYKKEVÆRK.',
    'Når du kontakter LYKKEVÆRK, er det mig, du taler med, og som udgangspunkt også mig, der kommer ud og ser på din opgave.',
    'Jeg hjælper private og virksomheder i Østjylland med montage, vedligeholdelse, mindre reparationer og praktiske opgaver i og omkring boligen eller virksomheden.',
    'Formålet er enkelt: du skal vide, hvem du har med at gøre, hvad opgaven koster, og hvornår jeg kommer.',
    'Er du i tvivl om, om jeg kan hjælpe med din opgave? Så spørg endelig — så får du et ærligt svar.',
  ],
}

/** Området jeg primært kører opgaver i. */
export const SERVICE_AREA = 'Østjylland'

/** Tre enkle trin fra henvendelse til udført opgave. */
export const steps = [
  {
    title: 'Du sender din opgave',
    description: 'Beskriv kort, hvad du skal have lavet, og send gerne et par billeder.',
  },
  {
    title: 'Jeg vender tilbage',
    description:
      'Jeg kigger på din opgave og kontakter dig, så vi kan afklare arbejdet, pris og tidspunkt.',
  },
  {
    title: 'Vi aftaler resten',
    description:
      'Når vi er enige om opgaven, finder vi et tidspunkt, og arbejdet bliver udført som aftalt.',
  },
]
